import { useTranslation } from "react-i18next";
import { AlertMessage } from "../../../components/alert-message";
import { OptResponse } from "./types";
import { Spacer } from "../../components/spacer";

export function OTPBanner({ deliveryMode }: { deliveryMode?: OptResponse }) {
    const { t } = useTranslation();
    return (
        <AlertMessage variant="success" title={t("login.code_success_header")}>
            <Spacer />
            <div>
                {t("login.code_success_title_1")}{" "}
                {deliveryMode?.deliverOption === "email" ? (
                    t("login.email")
                ) : (
                    <span>{t("login.phone")}</span>
                )}
                {t("login.code_success_title_3")}
                {t("login.code_success_title_4")}
                {deliveryMode?.deliverOption === "email" ? (
                    t("login.code_success_title_5")
                ) : (
                    <span>{t("")}</span>
                )}
            </div>
        </AlertMessage>
    );
}
